module.exports = __webpack_public_path__ + "img/ba_sk.6ded74d4.svg";